import * as Constants from '../constants/Constants';
import { setTabUsageDuration } from '../../redux/sideBarActions';

let timer;
let finalCheckTimer;

export const startTimer = () => (dispatch, getState) => {
  const activeTab = getActiveTabName(getState().sideBar.activeSideBarTab);
  dispatch(setTabUsageDuration(Date.now(), activeTab));
  dispatch(stopTimer());
};

export const startFinalCheckTimer = () => (dispatch, getState) => {
  const activeTab = getActiveTabName(getState().sideBar.activeSideBarTab);

  dispatch(setTabUsageDuration(Date.now(), activeTab));
  dispatch(stopTimer());
};

export const stopTimer = () => () => {
  clearInterval(timer);
};

export const stopFinalCheckTimer = () => () => {
  clearInterval(finalCheckTimer);
};

export const getActiveTabName = inActiveTab => {
  let activeTab = inActiveTab;
  if (activeTab === Constants.PHOTO_TAB_KEY) {
    activeTab = Constants.PHOTOS_KEY;
  } else if (activeTab === Constants.ELEMENT_TAB_KEY) {
    activeTab = Constants.OBJECTS_TYPE;
  } else if (activeTab === Constants.BACKGROUND_TAB_KEY) {
    activeTab = Constants.BACKGROUNDS_KEY;
  }
  return activeTab;
};
